const TextCounter = ({ title, value, style }) => {
  return (
    <div className="flex w-[100%] text-[0.85rem]" style={style}>
      <div data-testid="textcounter-title" className="w-[80%] text-left">
        {title ? title : "No Data"}
      </div>
      <div data-testid="textcounter-value" className="w-[20%] text-right">
        {value}
      </div>
    </div>
  );
};

export default TextCounter;
